import React from 'react'

const TranslationContext = React.createContext({});

export const TranslationProvider = TranslationContext.Provider;

export default TranslationContext
